import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ContactPayService } from 'src/app/public-website/buyer/services/contact-pay.service';
import { ContactSendOTPService } from 'src/app/public-website/buyer/services/contact-send-otp.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss'],
})
export class ContactComponent implements OnInit {
  contactInstallments = [];
  sendCodeClicked: boolean = true;
  sendFailed: string;
  nextStep: boolean = true;
  data: any;
  contactOption = this._formBuilder.group({
    option: ['', [Validators.required]],
  });
  contactOtp = this._formBuilder.group({
    otp: ['', [Validators.required, Validators.pattern(/^(.{6}$|$)/g)]],
  });

  constructor(
    private _formBuilder: FormBuilder,
    private sendOTPService: ContactSendOTPService,
    private payService: ContactPayService,
    private router: Router,
    private translate: TranslateService,
  ) {}

  ngOnInit(): void {
    this.data = JSON.parse(localStorage.getItem('contactData'));
    localStorage.removeItem('contactData');
    this.contactInstallments = this.data.Provider;
  }

  async sendOTP() {
    try {
      let optionChoose = {
        refNum: this.data.refNum,
        tenor: this.contactOption.controls['option'].value,
      };
      this.sendOTPService.setParams(optionChoose);
      const res = await this.sendOTPService.make();
      if (res.success) {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'OTP',
          text: `The OTP has been sent to this numner: ${res.data}`,
        });
      }
      this.nextStep = false;
      this.sendCodeClicked = false;
    } catch (e) {
      console.log(e);
      const msg = e?.faultyRequest?.error?.message;
      if (msg) {
        this.sendFailed = msg;
      } else {
        this.sendFailed = 'Unexpected Error';
      }
    }
  }

  async payment() {
    try {
      let paymentBody = {
        refNum: this.data.refNum,
        otp: this.contactOtp.controls['otp'].value,
      };
      this.payService.setParams(paymentBody);
      const res = await this.payService.make();
      if (res.success === true) {
        const url = localStorage.getItem('customerRedirectUrl');
        await Swal.fire({
          position: 'center',
          icon: 'success',
          text: this.translate.instant('BUYER_INFO.Contact.MessageSuccess'),
          showConfirmButton: false,
          showCancelButton: true,
        }).then((_) => {
          if (url) {
            const customerRedirectUrl = new URL(url);
            customerRedirectUrl.searchParams.set('status', 'success');
            customerRedirectUrl.searchParams.set(
              'providerRefNum',
              this.data.refNum,
            );
            customerRedirectUrl.searchParams.set(
              'customerReference',
              res.data.customerReference,
            );
            window.location.href = customerRedirectUrl.toString();
            return;
          }
          this.router.navigate(['/']);
        });
      }
    } catch (err) {
      console.log(err);
      const msg = err?.faultyRequest?.error?.message;
      if (msg) {
        this.sendFailed = msg;
      } else {
        this.sendFailed = 'Unexpected Error';
      }
    }
  }
}
